$(function(){
  var sp_nav = $('.header_sp_nav');
  var nav =$('.search-block');
  var main_cover = $('.main_cover');
  var search_hidden = $('.sp-visible_header>button');

  sp_nav.on('click',function(){
      setTimeout(function(){
        nav.fadeToggle(250);
      },200);
      sp_nav.toggleClass('active');
      main_cover.toggleClass('active');
      search_hidden.toggleClass('v-hidden');

      if(sp_nav.hasClass('active')){
          main_cover.on('click',function(){
              nav.fadeOut(250);
              setTimeout(function(){
                sp_nav.removeClass('active');
                main_cover.removeClass('active');
                search_hidden.removeClass('v-hidden');
              },350);
          });
      }
  });
});
